module.exports = __webpack_public_path__ + "img/safari-logo.37000b5a.svg";